/* eslint-disable */
import { useState, useEffect, useRef } from "react";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  uploadSingleFile,
  postData,

} from "utils/Gateway";

const aiUrl = "https://ai.lobees.com/generatefaq"; // AI endpoint URL
// const aiUrl = "http://127.0.0.1:8001/generatefaq"; // Local AI endpoint URL for testing

const CreateFaqsFromDocModal = ({
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isUploading, setIsUploading] = useState(false);
  const [uploadedDocUrl, setUploadedDocUrl] = useState("");
  const [uploadedDocId, setUploadedDocId] = useState(""); // To store uploaded document ID if needed
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [generateMsg, setGenerateMsg] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [docWordCount, setDocWordCount] = useState(0);
  const [tokenCount, setTokenCount] = useState(0);
  const [faqError, setFaqError] = useState("");
  const [openContextIdx, setOpenContextIdx] = useState(null); // For accordion
  const [selectedAi, setSelectedAi] = useState("gpt"); // Default: Gpt 4
  const [chunkSize, setChunkSize] = useState(1000); // New: Chunk size
  const [overlapSize, setOverlapSize] = useState(100); // New: Overlap size
  const [faqRatio, setFaqRatio] = useState(1.0); // New: FAQ ratio
  const [selectedPrompt, setSelectedPrompt] = useState(""); // Prompt selection
  const [customPrompt, setCustomPrompt] = useState(""); // Custom prompt
  const fileInputRef = useRef();

  // Handle file input change
  const handleFileChange = (e) => {
    setError("");
    setFile(e.target.files[0]);
  };

  // Handle file upload
  const docUploadHandler = async (e) => {
    if (e) e.preventDefault();
    setError("");
    if (!file) {
      setError("Please select a PDF file to upload.");
      return;
    }
    try {
      setIsUploading(true);
      setUploadedDocUrl("");
      let requestURL =
        url.API_BASE_URL +
        url.API_SINGLE_FILE_UPLOAD +
        `?token=${token}&textcontent=1`;

      const response = await uploadSingleFile(requestURL, file);

      console.log('response from uploadSingleFile:', response);

      if (response.status) {
        // add SERVER_URL with response.data.path
        const documentPath = url.SERVER_URL + response.data.path;

        setUploadedDocUrl(documentPath);
        setUploadedDocId(response.data?._id??""); // Store the uploaded document ID
        setIsUploading(false);

      }
    } catch (error) {
      setIsUploading(false);
      console.log(error.message);
    }
    resetDocFileInput();
  };

  // Callback to generate FAQ from uploaded document
  const generateFaq = async (docUrl) => {
    setIsGenerating(true);
    setGenerateMsg("Generating FAQ based on document uploaded...");
    setFaqList([]);
    setFaqError(""); // Reset error before generating
    try {
      let promptValue = null;
      
      const payload = {
        document_url: docUrl,
        aid: selectedAi || 'gpt',
        prompt: promptValue || '',
        max_tokens: Number(chunkSize) || 1000,
        overlap_tokens: Number(overlapSize) || 100,
        faq_ratio: parseFloat(faqRatio) || 1.0,
      };

      console.log('Payload for FAQ generation:', payload);

      const response = await postData(aiUrl, payload);

      console.log('response from postData:', response);

      if (response && response.qa_response && response.qa_response.length > 0) {
        setFaqList(response.qa_response);
        setFaqError("");
      } else {
        setFaqList([]);
        setFaqError("Failed to generate FAQ from document. No FAQ data received.");
      }

      setIsGenerating(false);
      setGenerateMsg("FAQ generation completed.");
    } catch (err) {
      setIsGenerating(false);
      setGenerateMsg("Failed to generate FAQ from document.");
      setFaqList([]);
      setFaqError("Failed to generate FAQ from document. Please try again.");
      console.log(err.message);
    }
  };

  // Reset file input
  const resetDocFileInput = () => {
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  // Handler to save FAQs (implement actual save logic as needed)
  const saveFaqHandler = async () => {

    if (!faqList || faqList.length === 0) {
      setFaqError("No FAQs available to save.");
      return;
    }

    const payload = {
      faqlist: faqList,
      documentid: uploadedDocId, // Include uploaded document ID if needed
    };

    try{
      let requestURL = url.API_BASE_URL;

      requestURL += url.API_CREATE_FAQ_BYLIST + `?token=${token}`;

      const response = await postData(requestURL, payload);

      console.log('response from postData for saveFaqHandler:', response);

      if (response.status) {

        //hide  modal
        let bootstrapModal = document.querySelector("#create_faq_from_doc");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        afterPopupClose();
        setFaqList([]);
        setUploadedDocUrl("");

      }

    }catch (error) {
      console.error("Error saving FAQs:", error);
    }

    


  };

  // Call FaqApiCall when uploadedDocUrl changes
  useEffect(() => {
    if (uploadedDocUrl) {
        console.log("Uploaded Document URL:", uploadedDocUrl);
      //FaqApiCall(uploadedDocUrl);
      generateFaq(uploadedDocUrl);
    }
  }, [uploadedDocUrl]);

  const promptOptions = [
    { value: "", label: "FAQ Default Prompt" },
  ];

  return (
    <div
      className="modal fade"
      id="create_faq_from_doc"
      tabIndex="-1"
      aria-labelledby="create_faq_from_doc"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="faqUploadModalLabel">
              Generate FAQs from Document (pdf/docx/txt)
            </h5>
            <button
              type="button"
              className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setUploadedDocUrl("");
                setFile(null);
                setError("");
                setIsGenerating(false);
                setGenerateMsg("");
                setSelectedAi("gpt-4");
                setSelectedPrompt("");
                setCustomPrompt("");
              }}
            ></button>
          </div>
          <form onSubmit={docUploadHandler}>
            <div className="modal-body">
              <div className="container-fluid">
                <div className="row align-items-center mb-3">
                  <div className="col-md-3 text-start">
                    <label htmlFor="docFile_faq" className="form-label fw-semibold">
                      Choose PDF to upload
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="file"
                      className="form-control border-grey"
                      accept=".pdf"
                      id="docFile_faq"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      disabled={isUploading || isGenerating}
                    />
                    {error && (
                      <div className="text-danger mt-2" style={{ fontSize: "0.95em" }}>
                        {error}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row align-items-center mb-3">
                  <div className="col-md-3">
                    <label htmlFor="ai_model_select" className="form-label fw-semibold">
                      Select AI Model
                    </label>
                    <select
                      id="ai_model_select"
                      className="form-select border border-secondary"
                      value={selectedAi}
                      onChange={e => setSelectedAi(e.target.value)}
                      disabled={isUploading || isGenerating}
                    >
                      <option value="gpt">Gpt 4</option>
                      <option value="anthropic">Claude Sonnet 3.5</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="chunk_size" className="form-label fw-semibold">
                      Chunk Size
                    </label>
                    <input
                      type="number"
                      className="form-control border border-secondary"
                      min={1}
                      id="chunk_size"
                      placeholder="Chunk Size"
                      value={chunkSize}
                      onChange={e => setChunkSize(e.target.value)}
                      disabled={isUploading || isGenerating}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="overlap_size" className="form-label fw-semibold">
                      Overlap Size
                    </label>
                    <input
                      type="number"
                      className="form-control border border-secondary"
                      min={0}
                      id="overlap_size"
                      placeholder="Overlap Size"
                      value={overlapSize}
                      onChange={e => setOverlapSize(e.target.value)}
                      disabled={isUploading || isGenerating}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="faq_ratio" className="form-label fw-semibold">
                      FAQ Ratio
                    </label>
                    <input
                      type="number"
                      className="form-control border border-secondary"
                      min={0}
                      step="0.01"
                      id="faq_ratio"
                      placeholder="FAQ Ratio"
                      value={faqRatio}
                      onChange={e => setFaqRatio(e.target.value)}
                      disabled={isUploading || isGenerating}
                    />
                  </div>
                </div>  
                <div className="row align-items-center mb-3">
                  <div className="col-md-3 text-start">
                    <label htmlFor="prompt_select" className="form-label fw-semibold">
                      Select Prompt
                    </label>
                  </div>
                  <div className="col-md-8">
                    <select
                      id="prompt_select"
                      className="form-select border border-secondary"
                      value={selectedPrompt}
                      onChange={e => setSelectedPrompt(e.target.value)}
                      disabled={isUploading || isGenerating}
                    >
                      {promptOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                    {selectedPrompt === "custom" && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Enter your custom prompt"
                        value={customPrompt}
                        onChange={e => setCustomPrompt(e.target.value)}
                        disabled={isUploading || isGenerating}
                      />
                    )}
                  </div>
                </div>
              </div>
              {(isUploading || isGenerating) && (
                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                  <div className="spinner-border text-primary mb-2" role="status" style={{ width: "2.5rem", height: "2.5rem" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="fw-semibold text-primary">
                    {isUploading
                      ? "File uploading in process..."
                      : generateMsg || "Generating FAQ based on document uploaded..."}
                  </div>
                </div>
              )}
              {faqError && (
                <div className="alert alert-danger mt-4" role="alert">
                  {faqError}
                </div>
              )}
              {faqList.length > 0 && (
                <div className="mt-4">
                  <h6 className="fw-bold mb-3">Generated FAQs</h6>

                  {/* selected aid */}
                  <div className="d-flex justify-content-between mb-2">
                    <h6>
                      Selected AI: { selectedAi === "gpt" ? "Gpt 4" : "Claude Sonnet 3.5" }
                    </h6>
                  </div>

                  <div className="faq-list">
                    {faqList.map((faq, idx) => (
                      <div key={idx} className="mb-3 p-3 border rounded bg-light">
                        <div className="fw-semibold mb-1 text-primary">
                          Q{idx + 1}: {faq.question}
                        </div>
                        <div className="mb-1">
                          <span className="fw-semibold">A:</span> {faq.answer}
                        </div>
                        
                        {faq.page && (
                          <div className="text-muted" style={{ fontSize: "0.9em" }}>
                            <span className="me-2">Page: {faq.page}</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={saveFaqHandler}
                    >
                      Save the Faqs to List
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isUploading || isGenerating}
              >
                {isUploading
                  ? "Uploading..."
                  : isGenerating
                  ? "Generating FAQ..."
                  : "Upload"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateFaqsFromDocModal;
